






















































































































































































































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { ScreenName } from '@/CommonUtils/fixed/ScreenName';
import { routingControlModule } from '../../store/modules/RoutingControl'; // ルーティング制御モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { applicationFormModule } from '../store/modules/ApplicationForm';
//2024/01/16 [2023L-14] add start
import { processHistoriesModule } from '../store/modules/ProcessHistories';
//2024/01/16 [2023L-14] add end
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import axios from 'axios';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class AccepterMainMenu extends ApiAccessBase {
  private tourokuShinseiName: string = '登録申請メニュー';
  private uketsukeSinkiName: string = '新規申請';
  private uketsukeSyuseiName: string = '申請書修正';
  private uketsukeKakuninName: string = '申請内容確認';
  private uketsukeHenkouName: string = '変更申請';
  private uketsukeKeizokuName: string = '継続申請';
  //2024/01/16 [2023L-14] add start
  private uketsukeRirekiName: string = '申請履歴';
  //2024/01/16 [2023L-14] add end
  private loginDec: string = '申請登録はこちら。';
  private uketsukeSinkiDec: string = '新規申請を実施したい場合はこちら。';
  private uketsukeSyuseiDec: string = '登録した申請書を修正したい場合はこちら。';
  private uketsukeKakuninDec: string = '登録した申請書の内容を確認したい場合はこちら。';
  private uketsukeHenkouDec: string = '変更申請を実施したい場合はこちら。';
  private uketsukekeizokuDec: string = '前年度にも申請しており、継続申請を実施したい場合はこちら。';
  private passwordChangeName: string = 'パスワード更新';
  private passwordChangeDec: string = 'パスワード更新はこちら。';
  // 2023/12/12 [2023L-06] add start
  private uketsukeTorikeshiName: string = '申請取消';
  private uketsukeTorikeshiDec: string = '受理前の申請を取り消したい場合はこちら。';
  // 2023/12/12 [2023L-06] add end
  // 2023/10/27 [2023L-10] add start
  private mailsentinfocreateName: string = 'メール送信情報追加';
  private mailsentinfocreateDec: string = 'メールの送信先を追加する場合はこちら。';
  // 2023/10/27 [2023L-10] add end
  //2024/01/16 [2023L-14] add start
  private uketsukeRirekiChangeDec: string = '申請の履歴を確認したい場合はこちら。';
  //2024/01/16 [2023L-14] add end

  // private getId() {
  //   //TODO ログアウト時に消されそうなので別のストアが必要かも。。。
  //  let id = supervisingModule.GET_TENANT_ID;
  //  if (!id) {
  //    // クエリストリングからidの取得
  //    const tempId = this.$route.query.id;
  //    if (typeof tempId === 'string') {
  //      id = tempId;
  //      // ストアに保存
  //      supervisingModule.setTenantId(id);
  //    }
  //  }
  //  return id;
  // }
  private createElementId: string = '';
  // 画面初期化
  private created() {
    this.screenTitle = '申請受付システムメインページ';
    // 使用する可変項目の名前を指定(複数指定可)
    if (applicationFormModule.CHECK_TYPE_CONST) {
      this.createElementId = 'accepter_mainmenu_const';
    } else if (applicationFormModule.CHECK_TYPE_CONSUL) {
      this.createElementId = 'accepter_mainmenu_consul';
    } else {
      this.createElementId = 'accepter_mainmenu_goods';
    }

    this.setVariablecolsState([this.createElementId]);
    const path: string = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/init';
    // TODO 登録画面から戻った際の再検索
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
      }
    });
  }
  /**
   * 対象データを検索
   * (ステータス判定OKの場合に発火(新規申請は除く))
   */
  private searchData(processType: string) {
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/search/' + processType;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        routingControlModule.registPrevious(this.$route.name);
        // traderIdとchangeTypeを渡す
        const tempData : any = this.resultData;
        applicationFormModule.setTraderId(tempData.traderId);
        applicationFormModule.setChangeType(tempData.changeType);
        if (applicationFormModule.GET_PROCESS_TYPE !== ApplicationProcessType.CHECK) {
          this.datalock(tempData.traderId);
        } else {
          //申請書確認は排他ロックせずに遷移
          router.push({ name: 'applicationForm' });
        }
      }
    });
  }
  /**
   * 画面遷移および排他lock（新規申請・申請書確認以外）
   */
  private datalock(traderId : string) {
    this.apiAccess(UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/exclusive/' + traderId, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        router.push({ name: 'applicationForm' });
      }
    });
  }

  //新規登録申請画面に遷移
  //(新規申請ボタン押下時に発火)
  private sinseinew() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + ApplicationProcessType.NEW;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setNendo(this.formData.nendo);
        applicationFormModule.setProcessType(ApplicationProcessType.NEW);
        // 次画面へ遷移
        router.push({ name: 'applicationForm' });
      }
    });
  }

  //申請書修正画面に遷移
  //(申請書修正ボタン押下時時に発火)
  private modify() {
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + ApplicationProcessType.CORRECT;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setProcessType(ApplicationProcessType.CORRECT);
        this.searchData(ApplicationProcessType.CORRECT);
      }
    });
  }

  //申請書確認画面に遷移
  //(申請書確認ボタン押下時時に発火)
  private check() {
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + ApplicationProcessType.CHECK;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setProcessType(ApplicationProcessType.CHECK);
        this.searchData(ApplicationProcessType.CHECK);
      }
    });
  }

  //変更申請画面に遷移
  //(変更申請ボタン押下時時に発火)
  private change() {
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + ApplicationProcessType.CHANGE;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setProcessType(ApplicationProcessType.CHANGE);
        this.searchData(ApplicationProcessType.CHANGE);
      }
    });
  }

  //継続申請画面に遷移
  //(継続申請ボタン押下時時に発火)
  private continued() {
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + ApplicationProcessType.CONTINUE;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setProcessType(ApplicationProcessType.CONTINUE);
        this.searchData(ApplicationProcessType.CONTINUE);
      }
    });
  }
  //2023/12/12 [2023L-06] add start
  /**
   * 申請取消処理
   */
  private cancela() {
    if (window.confirm(Message.I0038)) {
      // プロセスチェック（年度チェック含む）
      const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + 'cancela' + '/' + ApplicationProcessType.CANCEL;
      // APIアクセス
      this.apiAccess(path, Constants.API_METHOD_POST, true, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
        }
      });
    }
  }
  //2023/12/12 [2023L-06] add end

  //2024/01/16 [2023L-14] add start
  //申請履歴画面に遷移
  //(申請履歴ボタン押下時時に発火)
  private historiesa() {
    const path = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/' + ApplicationProcessType.HISTORY;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        const path2 = UketsukeConstants.ACCEPTER_MAINMENU_PATH + '/search/' + ApplicationProcessType.HISTORY;
        // APIアクセス
        this.apiAccess(path2, Constants.API_METHOD_POST, true, true)
        .then((result2) => {
          if (result2 === Constants.API_RESULT_SUCCES) {
            const tempData : any = this.resultData;
            processHistoriesModule.setTraderId(tempData.traderId);
            router.push({name: 'processHistories'});
          }
        });
      }
    });
  }
  //2024/01/16 [2023L-14] add end
  //ログアウト処理
  private logout() {
    axios.post(Constants.UKETSUKE_URL + '/logout')
          .then((response) => {
          // 成功
          router.push({name: ScreenName.LOGOUT});
        });
  }

}
